if (window.location.href.indexOf("gift-chocolate") > -1){
    window.location.replace("https://www.alevjewelry.com");
};


function $renderContainer(){

  /*$(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

    '<div class="container-progress-bar">' +
    
        '<h3 class="progress-bar__title">Gift chocolate on all orders</h3>'+
        
        '<section class="progress-bar-cart">'+
        
        	'<div class="progress-bar-cart__container">'+
        		'<div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>'+
        	'</div>'+
        
        	'<div class="progress-bar__icon">'+
        		'<div id="container-icon__free-shipping" class="progress-bar__icon-container">'+
        			'<i id="icon__free-shipping" class="fas fa-lock"></i>'+
        		'</div>'+
        		'<p class="progress-bar__icon-text">Gift Chocolate</p>'+
        	'</div>'+
        
        '</section>'+

        '<div class="disclaimer-message">'+

          '<p>*Chocolate bars will be shipped with every order up until 5 tickets are found.</p>' +
    
        '</div>' +

    '</div>'
  );*/

  
  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations").prepend(

    '<div class="content-gift-wrapping">' +

      '<div class="content-gift-wrapping__checkbox">'+

        '<div class="content-gift-wrapping__checkbox-container">' +

          '<input type="checkbox" id="gift-wrapping" onclick="verificarCheckbox()">' +
          '<label for="gift-wrapping"><img src="https://cdn.shopify.com/s/files/1/2704/9302/files/PACKING-ALEV-2.jpg"> Add gift wrapping (Free)</label>' +
    
        '</div>' +

      '</div>' +

      '<div class="container-card-gift-wrapping">' +

        '<div class="container-inputs">' +

          '<div class="container-inputs__textarea">' +
              '<p>Would you like to add a note?</p>' +
              '<textarea id="message-gift-wrapping" name="message-wrapping" placeholder="Add your note here."></textarea>' +
          '</div>' +

          '<div class="container-inputs__button">' +
              '<button class="add-message-wrapping">Add Wrapping</button>' +
          '</div>' +
          
        '</div>' +
        
      '</div>' +
    
    '</div>'
  );
  
};

function verificarCheckbox(){
  var checkbox = document.getElementById("gift-wrapping");
  if (checkbox.checked) {
    $('.container-card-gift-wrapping').slideDown();
  } else {
    $('.container-card-gift-wrapping').slideUp();
  }
};

function $giftWrapping(totalPrice,arrayProducts){
      
  var $total_price = totalPrice;
  var $array_products = arrayProducts;

  function $wrapping(id) {
    return id.product_id === 7890275991768;
  };

  var $addWrapping = $array_products.find($wrapping);
  
  // Condicional para mostrar la caja.

  if($addWrapping === undefined){

    if ($total_price > 0) {
      $('#rebuy-cart .content-gift-wrapping').show();                                         
    } else {
      $('#rebuy-cart .content-gift-wrapping').hide();
    };
    
  } else {

    if ($total_price > 0) {

      $('#rebuy-cart .content-gift-wrapping').hide();
      
      var $qty = $addWrapping.quantity;
      if($qty >= 2){
        jQuery.post('/cart/update.js', {
          updates: {
            43519497404632: 0
          }
        });
      };
      
    } else {

      jQuery.post('/cart/update.js', {
        updates: {
          43519497404632: 0
        }
      });

      $('#rebuy-cart .content-gift-wrapping').show();
      
    };
    
  };
  
};

function $progressBar(totalPrice,arrayProducts){
  
   var $total_price = totalPrice;
   var $array_products = arrayProducts;

    var $price_promotion_one = 1 - $total_price;
    var $promotion_one = $price_promotion_one /= Math.pow(10, 2);
    var $porcentPromotionOne = ((1 - $promotion_one) / 1 * 100) + "%";

    function $product_offer(productId) {
      return productId.product_id === 8027800371416;
    };

    var $validation_product = $array_products.find($product_offer);

    if($validation_product === undefined){

      if ($total_price <= 0) {

        $("#progress-bar__free-shipping").animate({width: "0%",}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
        $("#container-icon__free-shipping").css({"background-color": "white", "border-color": "transparent"});
        $("#icon__free-shipping").css("color", "#000000");
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Gift chocolate on all orders</h3>');
  
      } else if ($total_price > 0) {
  
        $("#progress-bar__free-shipping").animate({width: $porcentPromotionOne,}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
        $("#container-icon__free-shipping").css({"background-color": "transparent", "border-color": "transparent"});
        $("#icon__free-shipping").css("color", "white");
        
        var data = {
          "id": 43921593532632,
          "quantity": 1
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
            $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Added gift chocolate</h3>');
          }
        });
  
      };
      
    } else {

      var $qty_product = $validation_product.quantity;

      if ($total_price <= 0) {

        if($qty_product >= 1){
            jQuery.post('/cart/update.js', {
              updates: {
                43921593532632: 0
              }
            });
        };

        $("#progress-bar__free-shipping").animate({width: "0%",}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
        $("#container-icon__free-shipping").css({"background-color": "white", "border-color": "transparent"});
        $("#icon__free-shipping").css("color", "#000000");
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Gift chocolate on all orders</h3>');
  
      } else if ($total_price > 0) {

        if($qty_product >= 2){
          jQuery.post('/cart/update.js', {
            updates: {
              43921593532632: 0
            }
          });
        };
  
        $("#progress-bar__free-shipping").animate({width: $porcentPromotionOne,}, 500);
        $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
        $("#container-icon__free-shipping").css({"background-color": "transparent", "border-color": "transparent"});
        $("#icon__free-shipping").css("color", "white");
        $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Added gift chocolate</h3>');
  
      };
      
    };

};











document.addEventListener('rebuy:smartcart.ready', function(event){
  // console.log('rebuy:smartcart.ready event', event.detail);
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;
  $renderContainer();
  // $progressBar($total_price,$array_products);
  $giftWrapping($total_price,$array_products);
});

document.addEventListener('rebuy:cart.change', function(event){

  //console.log('rebuy:cart.change event', event.detail);

  var $qty_rebuy = event.detail.cart.cart.item_count;
  $('#CartCount span[data-cart-count]').text($qty_rebuy);

  var $containerProgress = $('#rebuy-cart .container-progress-bar');
  var $container = $('#rebuy-cart .content-gift-wrapping');
  var $total_price = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;

  if ($total_price <= 0) {
    $('#rebuy-cart .content-gift-wrapping').hide();
  };

  if ($containerProgress.length > 0) {
    // $progressBar($total_price,$array_products);
  }; 

  if ($container.length > 0) {
    $giftWrapping($total_price,$array_products);
  };  

});



$(document).on('click', '#rebuy-cart .container-inputs__button button.add-message-wrapping', function() {
  
  var $val = $('#message-gift-wrapping').val();
  
  if ( $val.length === 0 ){

    var data = {
      "id": 43519497404632,
      "quantity": 1
    };

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        $('#rebuy-cart .content-gift-wrapping').hide();
      }
    });
    
  } else {
    
    var data = {
      "id": 43519497404632,
      "quantity": 1,
      "properties": {
          'MESSAGE': $val
        }
    };

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        $('#rebuy-cart .content-gift-wrapping').hide();
      }
    });

    
  };
  
});